<template>
  <b-tooltip
    ref="tooltip"
    v-if="!isProUser"
    :triggers="['hover']"
    position="is-top"
    type="is-dark"
    multilined
    append-to-body
    class="pro-tag-with-upgrade-tooltip"
  >
    <ProTag @click.stop.native="upgrade" />
    <template v-slot:content>
      This is a preview of a premium feature. Upgrade your account to {{ upgradeIntent }}.
    </template>
  </b-tooltip>
</template>

<script>
import ProTag from '~/components/upgrade/ProTag'

export default {
  name: 'ProTagWithUpgradeTooltip',
  components: { ProTag },
  props: {
    upgradeIntent: {
      type: String,
      required: true
    }
  },
  computed: {
    isProUser () {
      return this.$store.getters.isProUser
    }
  },
  methods: {
    upgrade () {
      this.close()
      this.$emit('upgrade')
    },
    close () {
      // This is a bit hacky, but just using `.close()` will not work because of the `auto-close` prop.
      // @see node_modules/buefy/src/components/tooltip/Tooltip.vue
      this.$refs.tooltip.clickedOutside({ target: this.$el })
    }
  }
}
</script>

<style scoped lang="scss">
.pro-tag-with-upgrade-tooltip {
  position: absolute;
  cursor: pointer;
}
</style>
